import type { ReactNode } from "react"

interface ContainerProps {
  children: ReactNode
  className?: string
  size?: "sm" | "md" | "lg" | "xl" | "yoshinani" | "full"
}

export function Container({
  children,
  className = "",
  size = "yoshinani",
}: ContainerProps) {
  const sizeStyles = {
    sm: "max-w-3xl",
    md: "max-w-5xl",
    lg: "max-w-7xl",
    xl: "max-w-[1400px]",
    yoshinani: "max-w-yoshinani", // YOSHINANI 900px container
    full: "max-w-full",
  }

  return (
    <div className={`${sizeStyles[size]} mx-auto px-14 ${className}`}>
      {children}
    </div>
  )
}
